import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function InvestFactors({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/InvestPortfolio");
    };

    const goPrev = () => {
        navigate("/BuyAndSellStock");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Factors to Consider When Investing
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    When investing, it is important to take note of your current financial situation.  
                </div>
                <div className="text-[#000000] text-3xl">
                    Remember, low risk is still risk.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    Additionally, you should have an idea of the risk involved in your investment 
                </div>
                <div className="text-[#000000] text-3xl">
                    and what your risk tolerance is, or how much risk you think is okay for an 
                </div>
                <div className="text-[#000000] text-3xl">
                    investment.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    It is also important to know when the return on your investment will be.  It
                </div>
                <div className="text-[#000000] text-3xl">
                    does not matter how much the return will be if you will be dead before it comes.
                </div>
                <div className="text-[#000000] text-3xl">
                    Don’t invest too much in one thing or only one area.  Having a diverse set of 
                </div>
                <div className="text-[#000000] text-3xl">
                    investments will give you a safety net in case one investment does not work out.
                </div>
                <div className="text-[#000000] text-3xl font-bold mt-3">
                    DO NOT INVEST IN CRYPTO.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}